// src/router/index.js
import { createRouter, createWebHistory } from "vue-router";
import GuestLayout from "@/layouts/GuestLayout.vue";
import LoginView from "@/views/LoginView.vue";
import RegisterView from "@/views/RegisterView.vue";

const DefaultLayout = () => import("@/layouts/DefaultLayout.vue");
const UserProfileView = () => import("@/views/UserProfileView.vue");
const AccountInfoView = () => import("@/views/profile/AccountInfoView.vue");
const SocialAccountView = () => import("@/views/profile/SocialAccountView.vue");
const ChangePasswordView = () =>
  import("@/views/profile/ChangePasswordView.vue");
const NotificationsView = () => import("@/views/profile/NotificationsView.vue");
const HelpView = () => import("@/views/profile/HelpView.vue");

const routes = [
  {
    path: "/",
    component: DefaultLayout,
    meta: { requiresAuth: true }, // protect everything under DefaultLayout
    children: [
      {
        path: "",
        name: "home",
        component: () => import("@/views/HomeView.vue"),
      },
      {
        path: "userprofile",
        name: "userprofile",
        component: UserProfileView,
      },
      {
        path: "userprofile/account",
        name: "userprofile-account",
        component: AccountInfoView,
      },
      {
        path: "userprofile/social",
        name: "userprofile-social",
        component: SocialAccountView,
      },
      {
        path: "userprofile/password",
        name: "userprofile-password",
        component: ChangePasswordView,
      },
      {
        path: "userprofile/notifications",
        name: "userprofile-notifications",
        component: NotificationsView,
      },
      {
        path: "userprofile/help",
        name: "userprofile-help",
        component: HelpView,
      },
      {
        path: "/author/:id?",
        name: "author-profile",
        component: () => import("@/views/author/AuthorProfileView.vue"),
        meta: { requiresAuth: false },
      },
      {
        path: "/author/archived",
        name: "author-archived",
        component: () => import("@/views/author/ArchivedPostsView.vue"),
        meta: { requiresAuth: true }, // archived API requires auth
      },
      {
        path: "/people",
        name: "people",
        component: () => import("@/views/people/PeopleView.vue"),
        meta: { requiresAuth: false }, // search itself requires auth on the API; UI can still render
      },
    ],
  },
  {
    path: "/auth",
    component: GuestLayout,
    meta: { guestOnly: true }, // only for non-authenticated users
    children: [
      { path: "login", name: "login", component: LoginView },
      { path: "register", name: "register", component: RegisterView },
    ],
  },
  // {
  //   path: "/:pathMatch(.*)*",
  //   name: "not-found",
  //   component: () => import("@/views/NotFound.vue"),
  // },
  { path: "/:pathMatch(.*)*", redirect: { name: "home" } },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

// Global auth guard
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("auth_token");
  const isAuthed = !!token;
  const requiresAuth = to.matched.some((r) => r.meta.requiresAuth);
  const guestOnly = to.matched.some((r) => r.meta.guestOnly);

  // TEMP DEBUG
  console.log("[GUARD]", {
    to: to.fullPath,
    from: from.fullPath,
    requiresAuth,
    guestOnly,
    isAuthed,
    tokenPreview: token ? token.slice(0, 12) : null,
  });

  if (requiresAuth && !isAuthed) {
    return next({ name: "login", query: { redirect: to.fullPath } });
  }
  if (guestOnly && isAuthed) {
    return next({ name: "home" });
  }
  return next();
});

export default router;
